// extracted by mini-css-extract-plugin
export default {"container":"QO-z","modal":"RO-z","dimensions":"SO-z","brandName":"TO-z","productName":"UO-z","recipientEmail":"VO-z","recommendedFit":"WO-z","hiddenField":"XO-z"};